import { render, staticRenderFns } from "./Anchor.vue?vue&type=template&id=25478c92&"
import script from "./Anchor.vue?vue&type=script&lang=js&"
export * from "./Anchor.vue?vue&type=script&lang=js&"
import style0 from "./Anchor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports